module.exports = {
  "/": {
    "success": [
      "VISITOR_SUCCESS"
    ],
    "error": [
      "VISITOR_ERROR"
    ]
  }
};